import { useDebugValue, useState } from 'react';

export function useToggleableMap<T extends { id: number }>(
  defaultValues: T[] | undefined,
  maxSize?: number,
) {
  // HACK: setStateは`===`した結果がfalseだった時に再レンダリングされる
  //       `{} === {}`は必ずfalseになるので、それを利用しmapの更新を表現している
  const [, update] = useState({});
  const [map] = useState(() => {
    const map = new Map<number, T>();
    if (defaultValues) {
      defaultValues.forEach((it) => map.set(it.id, it));
    }
    return map;
  });

  const returnValues = {
    map: map as ReadonlyMap<number, T>,

    add(newValue: T) {
      if (maxSize != null && map.size >= maxSize) {
        return;
      }
      map.set(newValue.id, newValue);
      update({});
    },
    addOrDelete(newValue: T) {
      try {
        if (map.has(newValue.id)) {
          map.delete(newValue.id);
          return;
        }
        if (maxSize != null && map.size >= maxSize) {
          return;
        }
        map.set(newValue.id, newValue);
      } finally {
        update({});
      }
    },
    deleteAll() {
      for (const id of map.keys()) {
        map.delete(id);
      }
      update({});
    },
  };

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useDebugValue(map);
  }

  return returnValues;
}
